import React, { useContext, useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom'; // Import useHistory hook
import Image from './image';
import Logo from "../../assest/images/Logo.png";
import Icon1 from "../../assest/images/Icon1.png";
import Icon2 from "../../assest/images/Icon2.png";
import profile from "../../assest/images/profile.png";
import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../envconfig';
import { UserContext } from '../common/UserContext';

const Navbar = () => {
  const location = useLocation();
  const BYSCP = location.state?.BYSCP ?? null;
  const { UM_CompanyGrpID, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_DisplayName, UM_UserType } = useContext(UserContext);
  const [logoutVisible, setLogoutVisible] = useState(false);
  const [logoSrc, setLogoSrc] = useState(null);  // <-- for backend logo
  const navigate = useNavigate(); // Use the useHistory hook here
  const [notificationVisible, setNotificationVisible] = useState(false); // State for notification popup visibility
  const logoutRef = useRef(null);
  const notificationRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(profile);
  const logoutOnce = useRef(false);

  const toggleLogout = () => {
    setLogoutVisible(!logoutVisible);
  };
  useEffect(() => {
    fetchData();
  }, []);
  // fetch logo from backend
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/api/logo`, {
          responseType: "blob", // important for images
        });

        const url = URL.createObjectURL(response.data);
        setLogoSrc(url);
      } catch (error) {
        console.error("Error fetching logo:", error);
        // fallback: use static logo if backend not available
        setLogoSrc(require("../../assest/images/Logo.png"));
      }
    };

    fetchLogo();
  }, []);


  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await axios.post(
          `${config.API_URL}/UM/getimage`,
          { userId: UM_UserId },
          { responseType: "arraybuffer" } // important for binary data
        );

        // Convert buffer → blob → URL
        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        const url = URL.createObjectURL(blob);

        setImageSrc(url);
      } catch (error) {
        console.warn("No image found, using default:", error);
        setImageSrc(profile); // fallback
      }
    };

    fetchImage();
  }, [UM_UserId]);


  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;
    const AUTR_ScreenName = details.AUTR_ScreenName;

    const data = {
      AUTR_ScreenName: AUTR_ScreenName,
      AUTR_OldValue: AUTR_OldValue,
      AUTR_NewValue: AUTR_NewValue,
      AUTR_Message: AUTR_Message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_TimeStamp: currentTimestamp,
      AUTR_AuditType: AUTR_AuditType,
      AUTR_SCPID: UM_DefaultSCPId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
      AUTR_CreatedDateTime: currentTimestamp
    };

    try {
      const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
    
      return response.data;
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const fetchData = async () => {
    try {
      const response = await axios.get(`${config.API_URL}/getuserid`, { withCredentials: true });
      if (response.data == "NOT FOUND") {
      } else {
      
        const userID = response.data

       
        axios.get(`${config.API_URL}/getpath/${userID}`, { withCredentials: true })
          .then(function (response) {
           
            const userData = response.data;   // Store the response data in a variable
          })
          .catch(function (error) {
            console.error(error);
          });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

const handleLogout = () => {
  if (logoutOnce.current) return;
  logoutOnce.current = true;

  const companyCode = Cookies.get("CM_CompanyCode");
  const redirectPath = companyCode ? `/${companyCode}` : "/";

  Cookies.remove("UserName", { path: "/" });
  // Cookies.remove("CM_CompanyCode", { path: "/" });

  localStorage.removeItem("session_timeout");
  localStorage.removeItem("user_id");
  sessionStorage.clear();

  navigate(redirectPath, { replace: true });
   Cookies.remove("CM_CompanyCode", { path: "/" });

  window.location.reload();
};


  const [expiryData, setExpiryData] = useState(null);
  const [notificationData, setNotificationData] = useState(expiryData); // State for notification data
  useEffect(() => {


    fetchPasswordExpiry();
  }, [UM_UserCode]); // Trigger useEffect when userCode changes
  const fetchPasswordExpiry = async () => {
    try {
     
      const response = await axios.get(`${config.API_URL}/passwordexpiry/${UM_UserCode}`);
      const data = response.data;
      if (data && data.length > 0) {
        setExpiryData(data);
      } else {
        setExpiryData("NO DATA FOUND"); // Or handle as per your requirement
      }
    } catch (error) {
      console.error('Error fetching password expiry:', error);
    }
  };

  const toggleNotification = () => {
    if (notificationVisible) {
      const popupElement = document.querySelector('.notification-popup');
      popupElement.classList.add('fade-out');
      setTimeout(() => {
        setNotificationVisible(false);
      }, 300); // Match the animation duration
    } else {
      setNotificationVisible(true);
    }
    setntfcount(0)
    fetchPasswordExpiry();
    fetchData1();
  };


  const handleClickOutside = (event) => {
    if (notificationRef.current && !notificationRef.current.contains(event.target)) {
      setNotificationVisible(false);
    }
    if (logoutRef.current && !logoutRef.current.contains(event.target)) {
      setLogoutVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    if (UM_UserId) {
     
      fetchData1();
    }
  }, [UM_UserId]);
  //=========================================================================================
  //         Uncomment The below code if the updated is not working only for notification
  //=========================================================================================
  // const fetchData1 = async () => {
  //   try {
  //  
  //     const response = await axios.get(`${config.API_URL}/api/notify/${UM_UserId}`);
  //   
  //     setNotifications(response.data); // Assuming response.data is an array of notification objects
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };
  const fetchData1 = async () => {
    try {
      const response = await axios.get(`${config.API_URL}/api/notify/${UM_UserId}`,{
        params: {
          UM_UserType: UM_UserType,
          UM_CompanyID: UM_CompanyID
        }
      });
      setNotifications(response.data || []); // replace with fresh data
    } catch (error) {
      console.error('Error fetching data:', error);
      setNotifications([]);
    }
  };

  const [ordata, setordata] = useState();
  const [ordata1, setordata1] = useState();
  // const handleDoubleClick = async (data, msg) => {
  
  //   setNotificationVisible(false);
  //   let match = msg.match(/'([^']+)'/);

  //   if (!match) {
    
  //     return;
  //   }
  //   let textBetweenQuotes = match[1];
  //   try {
  //     const orderResponse = await fetch(`${config.API_URL}/pdf/orders/${textBetweenQuotes}`);
  //     if (!orderResponse.ok) {
  //       throw new Error('Failed to fetch order details');
  //     }
  //     const orderData = await orderResponse.json();
     
  //     setordata(orderData);

  //     const productResponse = await fetch(`${config.API_URL}/pdf/product/${textBetweenQuotes}`);
  //     if (!productResponse.ok) {
  //       throw new Error('Failed to fetch product details');
  //     }
  //     const productData = await productResponse.json();
     
  //     setordata1(productData);
  //     const popupContent = `
  //               <div class="resetpopup">
  //                   <h1>:: User Confirmation ::</h1>
  //                   <h4 >Are you sure want to acknowledge this message?</h4>
  //                    <h4>${msg}</h4>
                    
  //                   <div class="popup_btn_container">
  //                    <button id="yesbutton" class="notiyes_btn">YES</button>
  //                   <button id="view" class="notiview_btn">VIEW</button>
  //                   <button id="backButton" class="notino_btn">NO</button>
  //               </div>
  //             </div>
  //       `;

  //     // Create a div element for the popup content
  //     const popupContainer = document.createElement('div');
  //     popupContainer.innerHTML = popupContent;
  //     // Append the popup content to the document body
  //     document.body.appendChild(popupContainer);
  //     const viewbutton = document.getElementById('view');
  //     viewbutton.addEventListener('click', async () => {
  //       // Assuming textBetweenQuotes is defined somewhere
  //       if (textBetweenQuotes.startsWith('ORD_')) {
  //         // Navigate to home page logic
  //         window.location.href = `/dashboard/OrdView/${textBetweenQuotes}`; // Replace with your actual home page URL
  //       } else {
  //         window.location.href = `/shipmentview/${textBetweenQuotes}`; // Replace with your actual home page URL
  //       }
      
  //       const NFD_MessageId = data; // Replace with actual data
  //       const NFD_ACKW_By = UM_UserId; // Replace with actual data
        

  //       try {
  //         const response = await axios.post(`${config.API_URL}/api/insertNotification`, {
  //           NFD_MessageId,
  //           NFD_ACKW_By,
  //         });

          
  //         popupContainer.remove();
  //         document.body.classList.remove('blur-background');
  //         setntfcount(0)
  //         fetchPasswordExpiry();
  //         fetchData1();
  //         // Optionally, you can set state or handle success UI updates here
  //       } catch (error) {
  //         console.error('Error inserting data:', error);
  //         popupContainer.remove();
  //         document.body.classList.remove('blur-background');
  //         // Handle error states or UI notifications for failure
  //       }
  //     });

  //     const yesbutton = document.getElementById('yesbutton');
  //     yesbutton.addEventListener('click', async () => {
     
  //       const NFD_MessageId = data; // Replace with actual data
  //       const NFD_ACKW_By = UM_UserId; // Replace with actual data
       

  //       try {
  //         const response = await axios.post(`${config.API_URL}/api/insertNotification`, {
  //           NFD_MessageId,
  //           NFD_ACKW_By,
  //         });

          
  //         popupContainer.remove();
  //         document.body.classList.remove('blur-background');
  //         setntfcount(0)
  //         fetchPasswordExpiry();
  //         fetchData1();
  //         // Optionally, you can set state or handle success UI updates here
  //       } catch (error) {
  //         console.error('Error inserting data:', error);
  //         popupContainer.remove();
  //         document.body.classList.remove('blur-background');
  //         // Handle error states or UI notifications for failure
  //       }
  //     });
  //     // Attach event listener to the back button in the popup
  //     const backButton = document.getElementById('backButton');
  //     backButton.addEventListener('click', () => {
  //       // Close the popup
  //       popupContainer.remove();
  //       document.body.classList.remove('blur-background');
  //     });
  //     document.body.classList.add('blur-background');
  //   } catch (error) {
  //     console.error('Error handling double click:', error);
  //     // Handle error scenarios here
  //   }
  // };

  const handleDoubleClick = async (data, msg) => {
    setNotificationVisible(false);
  
    // Extract text inside single quotes (if exists)
    const match = msg.match(/'([^']+)'/);
    const textBetweenQuotes = match ? match[1] : null;
  
    try {
      // Fetch order/product data ONLY if match exists
      if (textBetweenQuotes) {
        try {
          const orderResponse = await fetch(
            `${config.API_URL}/pdf/orders/${textBetweenQuotes}`
          );
          if (orderResponse.ok) {
            const orderData = await orderResponse.json();
            setordata(orderData);
          }
  
          const productResponse = await fetch(
            `${config.API_URL}/pdf/product/${textBetweenQuotes}`
          );
          if (productResponse.ok) {
            const productData = await productResponse.json();
            setordata1(productData);
          }
        } catch (err) {
          console.warn("Optional fetch failed:", err);
        }
      }
  
      // Popup HTML (VIEW button only if match exists)
      const popupContent = `
        <div class="resetpopup">
          <h1>:: User Confirmation ::</h1>
          <h4>Are you sure want to acknowledge this message?</h4>
          <h4>${msg}</h4>
  
          <div class="popup_btn_container">
            <button id="yesbutton" class="notiyes_btn">YES</button>
            ${
              textBetweenQuotes
                ? `<button id="view" class="notiview_btn">VIEW</button>`
                : ``
            }
            <button id="backButton" class="notino_btn">NO</button>
          </div>
        </div>
      `;
  
      // Create popup
      const popupContainer = document.createElement("div");
      popupContainer.innerHTML = popupContent;
      document.body.appendChild(popupContainer);
      document.body.classList.add("blur-background");
  
      // YES → Acknowledge only
      document.getElementById("yesbutton").addEventListener("click", async () => {
        try {
          await axios.post(`${config.API_URL}/api/insertNotification`, {
            NFD_MessageId: data,
            NFD_ACKW_By: UM_UserId,
          });
  
          popupContainer.remove();
          document.body.classList.remove("blur-background");
          setntfcount(0);
          fetchPasswordExpiry();
          fetchData1();
        } catch (error) {
          console.error("ACK error:", error);
          popupContainer.remove();
          document.body.classList.remove("blur-background");
        }
      });
  
      // VIEW → Navigate + Acknowledge (only if match exists)
      if (textBetweenQuotes) {
        document.getElementById("view").addEventListener("click", async () => {
          if (textBetweenQuotes.startsWith("ORD_")) {
            window.location.href = `/dashboard/OrdView/${textBetweenQuotes}`;
          } else {
            window.location.href = `/shipmentview/${textBetweenQuotes}`;
          }
  
          try {
            await axios.post(`${config.API_URL}/api/insertNotification`, {
              NFD_MessageId: data,
              NFD_ACKW_By: UM_UserId,
            });
  
            popupContainer.remove();
            document.body.classList.remove("blur-background");
            setntfcount(0);
            fetchPasswordExpiry();
            fetchData1();
          } catch (error) {
            console.error("VIEW ACK error:", error);
            popupContainer.remove();
            document.body.classList.remove("blur-background");
          }
        });
      }
  
      // NO → Close popup
      document.getElementById("backButton").addEventListener("click", () => {
        popupContainer.remove();
        document.body.classList.remove("blur-background");
      });
  
    } catch (error) {
      console.error("Error handling double click:", error);
    }
  };
  
  const [ntfcount, setntfcount] = useState(0);
  //=========================================================================================
  //         Uncomment The below code if the updated is not working only for notification
  //=========================================================================================
  // useEffect(() => {
  //   const count = () => {
  //     if (expiryData !== "NO DATA FOUND") {
  //       setntfcount(1);
  //     }
  //   };
  //   count();
  // }, [expiryData, setntfcount]);

  // useEffect(() => {
  //   if (notifications) {
  //     setntfcount(ntfcount + notifications.length);
  //   }
  // }, [notifications, setntfcount]);
  useEffect(() => {
    let count = 0;
    if (expiryData !== "NO DATA FOUND" && Array.isArray(expiryData)) {
      count += 1;
    }
    if (Array.isArray(notifications)) {
      count += notifications.length;
    }
    setntfcount(count);
  }, [expiryData, notifications]);

  return (
    <>
      <nav>

        <div className='select_logo'>
          <span>
            {/* <Image src={Logo} alt="shubham_removebg" className="shubhamlogo" /> */}
            <img src={logoSrc} alt="Company Logo" className="shubhamlogo" />
          </span>
        </div>

        <div className='rightnav'>
          <div className="profile">
            <img src={imageSrc} alt="profile" className="proimage" />
            <span className="profilename">{UM_DisplayName}</span>
          </div>


          <div className="notification" ref={notificationRef}>
            <Link onClick={toggleNotification} state={{ BYSCP }}>
              <Image src={Icon1} alt="notification" className="bell" />
              {ntfcount > 0 && (
                <strong className={`notificationblink notCount ${ntfcount > 0 ? 'blink' : ''}`}>{ntfcount}</strong>
              )}
            </Link>


            {notificationVisible && (
              <div className="notification-popup" >
                <ul>
                  {Array.isArray(expiryData) && expiryData.length > 0 ? (
                    expiryData.map((notification, index) => (
                      <li className='notification_hover' key={index}>
                        Password will expire in {notification.DAYSLEFT} days on{' '}
                        {new Date(notification.EXPIRY_DATE).toLocaleDateString('en-GB')}
                      </li>
                    ))
                  ) : null}

                  {Array.isArray(notifications) && notifications.length > 0 ? (
                    notifications.map((notification) => (
                      <li className='notification_hover' key={notification.NFM_ID} onDoubleClick={() => handleDoubleClick(notification.NFM_ID, notification.NFM_EventMessage)}>
                        {notification.NFM_EventMessage}
                      </li>
                    ))
                  ) : null}

                  {(!Array.isArray(expiryData) || expiryData.length === 0) && (!Array.isArray(notifications) || notifications.length === 0) && (
                    <li>No notifications</li>
                  )}
                </ul>
              </div>
            )}

          </div>

          <div className="logout" ref={logoutRef}>
            <Link onClick={toggleLogout} state={{ BYSCP }}><Image src={Icon2} alt="menu" className="menu" /></Link>
            {logoutVisible && (
              <><Link onClick={handleLogout} state={{ BYSCP }}>
                <div className="logout-popup" onClick={handleLogout}>
                  <button className='logout_btn' onClick={handleLogout}>LOGOUT</button>
                </div>
              </Link></>
            )}
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;

